var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Content',{attrs:{"title":"SLA Performance Praqualifikasi KPLH"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }